// extracted by mini-css-extract-plugin
module.exports = {"summary":"FileDownloadModal_summary_KfYBz"};